const ContactForm = {
	init() {
		this.contactFormTabs();
		this.contactFormToken();
		this.contactFormSubmit();
		this.contactFormScrollButton();
	},

	contactFormToken() {
		const forms = document.querySelectorAll(".contact-form");

		forms.forEach((form) => {
			this.refreshContactFormToken(form);
		});
	},

	async refreshContactFormToken(form) {
		if (!form.dataset.tokenUrl) {
			return;
		}

		try {
			// Fetches a submission token; see ContactFormApi::getToken(). Each
			// token is single-use, so this also runs again after a successful
			// submit — see contactFormSubmit().
			const tokenResponse = await fetch(form.dataset.tokenUrl, {
				method: "GET",
				credentials: "omit",
				cache: "no-store",
			});

			const tokenResult = await tokenResponse.json();
			const token = tokenResult.token || "";

			form.querySelectorAll(".js-contact-form-token").forEach((field) => {
				field.value = token;
			});
		} catch (error) {
			// Left empty on purpose; submit() handles a missing token.
		}
	},

	updateDynamicFields() {
		document.querySelectorAll(".dynamic").forEach((div) => {
			const enable = div.classList.contains("active");

			div.querySelectorAll("input, select, textarea").forEach((field) => {
				field.disabled = !enable;
			});
		});
	},

	removeResponseAlert() {
		const responseDiv = document.querySelector(".contact-form-response");

		if (responseDiv) {
			const innerDiv = responseDiv.querySelector("div");

			if (innerDiv) {
				innerDiv.remove();
			}
		}
	},

	removeFieldErrorClass(formElement) {
		formElement.querySelectorAll(".field.error").forEach((field) => {
			field.classList.remove("error");
		});
	},

	contactFormScrollButton() {
		const button = document.querySelector(".js-scroll-to-form");

		if (!button) {
			return;
		}

		button.addEventListener("click", () => {
			const section = button.closest(".js-contact-form");

			if (!section) {
				return;
			}

			const formTarget = section.querySelector("#contact-form-target");

			if (!formTarget) {
				return;
			}

			formTarget.scrollIntoView({
				behavior: "smooth",
				block: "start",
			});
		});
	},

	contactFormTabs() {
		const forms = document.querySelectorAll(".js-contact-form");

		if (!forms.length) {
			return;
		}

		this.updateDynamicFields();

		forms.forEach((form) => {
			const tabs = form.querySelectorAll(".tab");
			const formPanels = form.querySelectorAll(".dynamic");
			const contactPanels = form.querySelectorAll(".contact-pane");

			tabs.forEach((tab) => {
				tab.addEventListener("click", () => {
					const target = tab.dataset.tab;

					tabs.forEach((item) => {
						item.classList.remove("active");
					});

					formPanels.forEach((panel) => {
						panel.classList.remove("active");
					});

					contactPanels.forEach((panel) => {
						panel.classList.remove("active");
					});

					tab.classList.add("active");

					const targetForm = form.querySelector(`#${target}`);

					if (targetForm) {
						targetForm.classList.add("active");
					}

					const targetContact = form.querySelector(
						`[data-contact="${target}"]`,
					);

					if (targetContact) {
						targetContact.classList.add("active");
					}

					const formWrap = document.querySelector(
						"#wohngut-forms .form-wrap",
					);

					if (
						window.matchMedia("(max-width: 767px)").matches &&
						formWrap
					) {
						formWrap.scrollIntoView({
							behavior: "smooth",
							block: "start",
						});
					}

					this.updateDynamicFields();
					this.removeFieldErrorClass(form);
					this.removeResponseAlert();
				});
			});
		});
	},

	contactFormSubmit() {
		const forms = document.querySelectorAll(".contact-form");

		if (!forms.length) {
			return;
		}

		forms.forEach((form) => {
			form.addEventListener("submit", async (event) => {
				event.preventDefault();

				const submitButton = form.querySelector(".submit");

				if (!submitButton || submitButton.disabled) {
					return;
				}

				const originalButtonText = submitButton.innerHTML;

				submitButton.disabled = true;
				submitButton.classList.add("is-loading");
				submitButton.innerHTML =
					window.wohngutContactForm?.sendingLabel ??
					"Wird gesendet...";

				const activePanel = form.querySelector(".dynamic.active");

				if (!activePanel) {
					return;
				}

				// The token itself was already fetched and filled in by
				// contactFormToken() on page load — see that function for why.

				const formData = new FormData();

				const activeFields = activePanel.querySelectorAll(
					"input, select, textarea",
				);

				activeFields.forEach((field) => {
					if (!field.name) {
						return;
					}

					if (field.name === "form_consent") {
						formData.append(field.name, field.checked);
						return;
					}

					if (field.type === "checkbox" && !field.checked) {
						return;
					}

					if (field.type === "radio" && !field.checked) {
						return;
					}

					formData.append(field.name, field.value);
				});

				const honeypot = form.querySelector('[name="person_height"]');

				if (honeypot) {
					formData.append(honeypot.name, honeypot.value);
				}

				const responseContainer = form.querySelector(
					".contact-form-response",
				);

				try {
					// credentials intentionally "omit" — see ContactFormApi::registerRoutes().
					const response = await fetch(form.dataset.restUrl, {
						method: "POST",
						credentials: "omit",
						body: formData,
					});

					const result = await response.json();

					submitButton.disabled = false;
					submitButton.classList.remove("is-loading");
					submitButton.innerHTML = originalButtonText;

					if (responseContainer) {
						this.removeFieldErrorClass(form);

						responseContainer.innerHTML = "";

						if (result.success) {
							responseContainer.innerHTML = `
                                <div class="success-message">
                                    ${result.message}
                                </div>
                            `;

							this.removeFieldErrorClass(form);

							form.reset();

							this.refreshContactFormToken(form);
						} else {
							let html = "";

							if (result.errors && result.errors.length) {
								html += "<ul>";

								result.errors.forEach((error) => {
									html += `<li>${error.message}</li>`;

									let fieldElement =
										activePanel.querySelector(
											`[name="${error.field}"]`,
										);

									if (!fieldElement) {
										fieldElement =
											activePanel.querySelector(
												`[name="${error.field}[]"]`,
											);
									}

									if (fieldElement) {
										const fieldWrapper =
											fieldElement.closest(".field");

										if (fieldWrapper) {
											fieldWrapper.classList.add("error");
										}
									}
								});

								html += "</ul>";
							} else if (result.message) {
								html = result.message;
							}

							responseContainer.innerHTML = `
                                <div class="error-message">
                                    ${html}
                                </div>
                            `;
						}
					}
				} catch (error) {
					if (responseContainer) {
						const genericErrorMessage =
							window.wohngutContactForm?.genericErrorMessage ??
							"Es ist ein Fehler aufgetreten. Bitte versuche es erneut.";

						responseContainer.innerHTML = `
                            <div class="error-message">
                                ${genericErrorMessage}
                            </div>
                        `;
					}
				} finally {
					submitButton.disabled = false;
					submitButton.classList.remove("is-loading");
					submitButton.innerHTML = originalButtonText;

					if (responseContainer) {
						responseContainer.scrollIntoView({
							behavior: "smooth",
							block: "nearest",
						});
					}
				}
			});
		});
	},
};

export default ContactForm;
